import type { App, DirectiveBinding } from 'vue';
import { createApp } from 'vue';
import CyBtnLoading from '@/components/ui/cy-btn-loading.vue';
import { getSkeleton } from './skeleton';
import globalUI from "@/plugins/global-ui"

type BtnLoadingType =  InstanceType<typeof CyBtnLoading>;

const debug = import.meta.env.DEV;
const loadingLockClass = 'loading-lock';
const skeletonRelative = 'skeleton-relative';
const skeletonAbsoulte = 'skeleton-absoulte';

// 挂在的dom
const appendChildEl = (el: HTMLElement & { instance: any }) => {
  if (!el?.childNodes?.[0] && debug) {
    console.error('指令挂载的dom里面没有孩子');
  };
  if (!el?.childNodes?.[0]) {
    el.appendChild(el.instance.$el);
  } else {
    el.insertBefore(el.instance.$el, el.childNodes?.[0]);
  }
};
const removeChildEl = (el: HTMLElement & { instance: any }) => {
  el.removeChild(el.instance.$el);
};
const getConfig = (modifiers: any, arg: any): { theme: "white" | "black", size: string } => {
  let theme = 'white' as "white" | "black";
  if (modifiers.black) {
    theme = 'black';
  };
  if (modifiers.white) {
    theme = 'white';
  };
  return {
    theme,
    size: arg,
  }
};
const changeLockClass = (el: HTMLElement, isLock: boolean) => {
  if (isLock) {
    el.classList.add(loadingLockClass);
  } else {
    el.classList.remove(loadingLockClass);
  }
}

// 骨架挂载添加样式
const skeletonAddClass = (rootEl: HTMLElement, mountEl: HTMLElement) => {
  rootEl.classList.add(skeletonRelative);
  mountEl.classList.add(skeletonAbsoulte);
}
const skeletonRemoveClass = (rootEl: HTMLElement, mountEl: HTMLElement) => {
  rootEl.classList.remove(skeletonRelative);
  mountEl.classList.remove(skeletonAbsoulte);
}


export default {
  install(app: App<HTMLElement>) {

    app.directive('focus', {
      mounted(el) {
        el.focus();
      }
    });

    // 挂载骨架屏幕
    app.directive('skeleton', {
      mounted(el: HTMLElement & {[skeletonComName:string]: any}, binding: DirectiveBinding<boolean>) {
        const { arg, value, } = binding;
        const currentSkeletonCom = getSkeleton(arg as any)
        if (!currentSkeletonCom && debug) {
          console.error('请提供必要的骨架组件')
        };
        if (currentSkeletonCom) {
          const skeletonApp = createApp(currentSkeletonCom);
          skeletonApp.use(globalUI);
          const instance = skeletonApp.mount(document.createElement('div'));
          const skeletonComName = currentSkeletonCom.name;

          if (!el[skeletonComName]) {
            el[skeletonComName] = {};
          }
          el[skeletonComName].instance = instance;
          // 如果需要挂载该骨架组件
          if (value) {
            skeletonAddClass(el, instance.$el);
            el.appendChild(instance.$el);
          }
        }
      },
      updated(el: HTMLElement & {[skeletonComName:string]: any}, binding: DirectiveBinding<boolean>) {
        const { oldValue, value, arg } = binding;
        const currentSkeletonCom = getSkeleton(arg as any);
        const skeletonComName = currentSkeletonCom!.name;
        if (oldValue !== value) {
          // 要更新了
          if (value) {
            skeletonAddClass(el, el[skeletonComName].instance.$el);
            el.appendChild(el[skeletonComName].instance.$el);
          } else {
            skeletonRemoveClass(el, el[skeletonComName].instance.$el);
            el.removeChild(el[skeletonComName].instance.$el);
          }
        }
      }
    })

    //  v-btn-loading:[size].white.black.isLock
    //  size是图片的大小px
    //  white black 是圈的类型 白色 还是 黑色
    //  isLock 是否要锁用
    app.directive('btn-loading', {
      mounted(el: HTMLElement & { instance: any }, binding: DirectiveBinding<boolean>) {
        const { value, modifiers, arg } = binding;
        const loadingApp = createApp(CyBtnLoading);
        const mountDiv = document.createElement('div');
        const loadingInstance = loadingApp.mount(mountDiv) as BtnLoadingType;
        el.instance = loadingInstance;
        const { theme, size } = getConfig(modifiers, arg);
        loadingInstance?.changeInfo(size, theme);
        if (value) {
          appendChildEl(el);
          changeLockClass(el, modifiers.isLock);
        }
      },
      updated(el: HTMLElement & { instance: any }, binding: DirectiveBinding<boolean>) {
        const { oldValue, value, modifiers, arg } = binding;
        const { theme, size } = getConfig(modifiers, arg);
        el.instance?.changeInfo(size, theme);
        if (oldValue !== value) {
          value ? appendChildEl(el) : removeChildEl(el);
          value ? changeLockClass(el, true) : changeLockClass(el, false);
        };
      }
    })
  }
}

